import { getSelectedCalendars } from './getSelectedCalendars';

export function getSelectedCalendarsForMailbox(primarySmtpAddress: string): string[] {
    const selectedCalendars = getSelectedCalendars().get(primarySmtpAddress);
    return selectedCalendars ? selectedCalendars : [];
}
